import { request, ROUTES } from "./api";

function normalizeMeta(meta, fallbackPage, fallbackLimit) {
  return {
    page: Number(meta?.page || fallbackPage || 1),
    limit: Number(meta?.limit || fallbackLimit || 10),
    total: Number(meta?.total || 0),
    totalPages: Math.max(1, Number(meta?.totalPages || 1)),
  };
}

export const getOrders = async ({ page = 1, limit = 10, status = null, q = "", signal } = {}) => {
  const params = { page, limit };
  if (status) params.status = status;
  if (String(q || "").trim()) params.q = String(q).trim();

  const data = await request({
    url: ROUTES.orders,
    method: "GET",
    params,
    signal,
  });

  return {
    items: Array.isArray(data?.items) ? data.items : [],
    meta: normalizeMeta(data?.meta, page, limit),
  };
};

export const cancelOrder = async (orderId, { reason, signal } = {}) => {
  if (!orderId) {
    throw new Error("Request failed: Missing order id");
  }

  return request({
    url: `${ROUTES.orders}/${orderId}`,
    method: "PUT",
    data: { status: "CANCELLED", reason },
    signal,
  });
};

export const settleOrderPayment = async (orderId, { clientRequestId, allowSessionRenewal = true, returnFlow, signal } = {}) => {
  if (!orderId) {
    throw new Error("Request failed: Missing order id");
  }

  return request({
    url: `${ROUTES.orders}/${orderId}/settle-payment`,
    method: "POST",
    data: {
      clientRequestId,
      allowSessionRenewal,
      ...(returnFlow ? { returnFlow } : {}),
    },
    signal,
  });
};

export const requestReturnRefund = async (orderId, { reason, reasonCode, details, policyAccepted, media = [], signal } = {}) => {
  if (!orderId) {
    throw new Error("Request failed: Missing order id");
  }

  const formData = new FormData();
  formData.append("reason", reason || "");
  if (reasonCode) {
    formData.append("reasonCode", reasonCode);
  }
  if (details) {
    formData.append("details", details);
  }
  formData.append("policyAccepted", policyAccepted ? "true" : "false");
  (Array.isArray(media) ? media : []).forEach((file) => {
    if (file) formData.append("media", file);
  });

  return request({
    url: `${ROUTES.orders}/${orderId}/return-request`,
    method: "POST",
    data: formData,
    signal,
  });
};
